
const RentalAndLeasePrices = (props) => {
    return (  
        <>
            {props.PriceGroup && props.PriceGroup.length > 0 && 
                <div className='other-site-data-section'>
                    <div className={props.IsRY ? 'rent-lease-ry' : 'rent-lease'}>
                        {props.PriceGroup.map((priceGroupModel) =>
                            <div key={priceGroupModel.Name} className={priceGroupModel.ParentDivClassName}>
                                <span className={priceGroupModel.MainDivClassName}>{priceGroupModel.Name}</span>
                                <span className={priceGroupModel.ChildDivClassName}>
                                    {priceGroupModel.PriceGroup.map((listingPriceModel) =>
                                        <div key={listingPriceModel.Name}>
                                            <span className='price-type'><strong>{listingPriceModel.Name}</strong></span><span className={listingPriceModel.PriceClassName}>{listingPriceModel.Price}{listingPriceModel.LeaseInfo}</span>
                                            {listingPriceModel.PriceEnteredAs && props.ShowPriceEnteredAs &&
                                                <div className='price-entered-as'>{listingPriceModel.PriceEnteredAs}</div>}
                                        </div>)}
                                </span>
                                {priceGroupModel.PricingDescription &&
                                    <span className={priceGroupModel.ChildDivClassName}>{priceGroupModel.PricingDescriptionLabel}&nbsp;{priceGroupModel.PricingDescription}</span>}
                            </div>)}
                    </div>
                </div>}
        </>
    );
};

export default RentalAndLeasePrices;